// import ViewResource from "@swivu/shared-ui/src/components/ViewResource.js";
import ResourceDetail from "@swivu/team-schedule/src/shared-public-and-wf/ResourceDetail.js";
import { useParams } from "react-router-dom";
import { useSettings } from "../hooks/useSettings.js";

const ViewResourcePublic = () => {
  const { slug, resource_id } = useParams<{
    slug: string;
    resource_id: string;
  }>();
  const { timezone } = useSettings();
  const baseUrls = {
    checklist: `/p/${slug}/checklist/:id`
  };
  return (
    <ResourceDetail.Provider
      api="public"
      id={resource_id!}
      slug={slug!}
      timezone={timezone}
      baseUrls={baseUrls}
    >
      <div className="py-4">
        <ResourceDetail />
      </div>
    </ResourceDetail.Provider>
  );
};

export default ViewResourcePublic;
